import baseMarkupSchema from './base-schema';
import breadcrumbListMarkupSchema from './breadcrumb-list';
import collectionPageMarkupSchema from './collection-page';
import organizationMarkupSchema from './organization';
import webSiteMarkupSchema from './web-site';
import webPageMarkupSchema from './web-page';
import musicRecordingMarkupSchema from './music-recording';
import personMarkupSchema from './person';
import itemListMarkupSchema from './item-list';
import mobileApplicationMarkupSchema from './mobile-application';

export {
  baseMarkupSchema,
  breadcrumbListMarkupSchema,
  collectionPageMarkupSchema,
  organizationMarkupSchema,
  webSiteMarkupSchema,
  webPageMarkupSchema,
  musicRecordingMarkupSchema,
  personMarkupSchema,
  itemListMarkupSchema,
  mobileApplicationMarkupSchema,
};
